import { render, staticRenderFns } from "./scorecard-order-confirmation.vue?vue&type=template&id=63db48e9&scoped=true"
import script from "./scorecard-order-confirmation.vue?vue&type=script&lang=js"
export * from "./scorecard-order-confirmation.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-confirmation.vue?vue&type=style&index=0&id=63db48e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db48e9",
  null
  
)

export default component.exports